if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient')
                this.modalContent.classList.add(classApplied);
            });
            
            
            this.customElementsQuickAddDrawer();
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
            
           

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            // commented the function below for custom fetching of product section
            //this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }


      // Function to customize the element inside quick add drawer
      // customElementsQuickAddDrawer(){

      //   const productInfoContainer = this.productElement.querySelector('.product__info-container');
      //   const breadcrumbs = this.productElement.querySelector('.nf-breadcrumb');
      //   const nfBadge =  this.productElement.querySelector('.nf-badge-container');
      //   const productButton = this.productElement.querySelector('product-form');
      //   const productButtonMobile =  this.productElement.querySelector('#mobile-form');
      //   const productTitle = this.productElement.querySelector('.product__title');
      //   const productPrice = this.productElement.querySelector('.price');
      //   productPrice.parentNode.classList.add('quick-add-price-element');
      //   const quickAddPriceElement = this.productElement.querySelector('.quick-add-price-element');
      //   const productText = this.productElement.querySelector('.product__text');
      //   const productShorDescription = this.productElement.querySelector('#pdp-short-description');
      //   const uspProductCard = this.productElement.querySelector('.usp-product-card');
      //   const uspWrap = this.productElement.querySelectorAll('.usp-wrap');
      //   const mostSuitedFor = this.productElement.querySelector('.most-suited-for-drawer-icon');
      //   const mediaWrapper = this.productElement.querySelector('.product__media-wrapper');
      //   const mediaGallery = this.productElement.querySelector('media-gallery');
      //   const viewFullDetail = this.productElement.querySelector('.product__view-details');
      //   const stockWrapper = this.productElement.querySelector('#stock-text-wrapper');
      //   const productPayment = this.productElement.querySelector('.product__payment');
      //   const optionExplanation = this.productElement.querySelector('.explanation-dialog-btn');
      //   const inputRadioMostPrequentylyChosen = this.productElement.querySelector('input[most-frequently-chosen="true"]');
      //   const pdpKlaviyoBtn = this.productElement.querySelector('.klaviyo-bis-trigger');
      

      //   //app blocks
      //   const trustPilotWidget =  this.productElement.querySelector('.trustpilot-widget');
      //   const estimatedShippingWidget =  this.productElement.querySelector('.ot-estimated-shipping');
      //   const judgemePreviewBadge =  this.productElement.querySelector('.jdgm-preview-badge');
      //   judgemePreviewBadge.parentNode.classList.add('jdgm-preview-badge-container');
      //   const judgemePreviewBadgeContainer = this.productElement.querySelector('.jdgm-preview-badge-container');

      //   if(inputRadioMostPrequentylyChosen) {
      //     const inputRadioMostPrequentylyChosenVariantId = inputRadioMostPrequentylyChosen.getAttribute('most-frequently-chosen-variant-id');
      //     this.productElement.querySelector('.product-variant-id').setAttribute('value', inputRadioMostPrequentylyChosenVariantId);
      //   }

      //   if(breadcrumbs){
      //     breadcrumbs.remove();
      //   }

      //   if(nfBadge){
      //     nfBadge.remove();
      //   }

      //   if(productButtonMobile){
      //     productButtonMobile.remove();
      //   } 

      //   if(productTitle){
      //     productTitle.remove();
      //   }
        

      //   if(quickAddPriceElement){
      //     quickAddPriceElement.remove();
      //   }
        

      //   if(productText){
      //     productText.remove();
      //   }
        

      //   if(productShorDescription){
      //     productShorDescription.remove();
      //   }
        
        
      //   if(uspProductCard){
      //     uspProductCard.remove();
      //   }

      //   // if(mostSuitedFor) {
      //   //   mostSuitedFor.remove();
      //   // }
       

      //   if(mediaWrapper){
      //     mediaWrapper.remove();
      //   }
        

      //   if(mediaGallery){
      //     mediaGallery.remove();
      //   }
        

      //   if(viewFullDetail) {
      //     viewFullDetail.remove();
      //   }

      //   if(stockWrapper){
      //     stockWrapper.remove();
      //   }

      //   if(productPayment){
      //     productPayment.remove();
      //   }

      //   // if(optionExplanation){
      //   //   optionExplanation.remove();
      //   // }

      //   if(uspWrap){
      //     uspWrap.forEach((usp) => {
      //       usp.remove();
      //     });
      //   }

      //   if(trustPilotWidget) {
      //     trustPilotWidget.remove();
      //   }

      //   if(estimatedShippingWidget) {
      //     estimatedShippingWidget.remove();
      //   }

      //   if(judgemePreviewBadgeContainer){
      //     judgemePreviewBadgeContainer.remove();
      //   }

      //   if(pdpKlaviyoBtn) {
      //     pdpKlaviyoBtn.remove();
      //   }

      //   const producttitleAndImage = document.createElement('div');
      //   producttitleAndImage.classList.add('main-product-drawer-image');
      //   const productTitleAndPrice = document.createElement('div');
      //   productTitleAndPrice.classList.add('main-product-drawer-title-price');

      //   productTitleAndPrice.appendChild(productTitle);
      //   productTitleAndPrice.appendChild(productText);
      //   productTitleAndPrice.appendChild(quickAddPriceElement);
      //   //productTitleAndPrice.appendChild(judgemePreviewBadgeContainer);
      //   productTitleAndPrice.appendChild(viewFullDetail);

      //   producttitleAndImage.appendChild(mediaGallery);
      //   producttitleAndImage.appendChild(productTitleAndPrice);
        
      //   productInfoContainer.prepend(producttitleAndImage);

      // }

      customElementsQuickAddDrawer() {
        // Helper function to safely manipulate elements
        const safeOperation = (element, operation) => {
          if (element) {
            operation(element);
          }
        };
      
        // Get all elements with null checks
        const productInfoContainer = this.productElement.querySelector('.product__info-container');
        const breadcrumbs = this.productElement.querySelector('.nf-breadcrumb');
        const nfBadge = this.productElement.querySelector('.nf-badge-container');
        const productButton = this.productElement.querySelector('product-form');
        const productButtonMobile = this.productElement.querySelector('#mobile-form');
        const productTitle = this.productElement.querySelector('.product__title');
        const productPrice = this.productElement.querySelector('.price');
        const productText = this.productElement.querySelector('.product__text');
        const productShorDescription = this.productElement.querySelector('#pdp-short-description');
        const uspProductCard = this.productElement.querySelector('.usp-product-card');
        const uspWrap = this.productElement.querySelectorAll('.usp-wrap');
        const mostSuitedFor = this.productElement.querySelector('.most-suited-for-drawer-icon');
        const mediaWrapper = this.productElement.querySelector('.product__media-wrapper');
        const mediaGallery = this.productElement.querySelector('media-gallery');
        const viewFullDetail = this.productElement.querySelector('.product__view-details');
        const stockWrapper = this.productElement.querySelector('#stock-text-wrapper');
        const productPayment = this.productElement.querySelector('.product__payment');
        const optionExplanation = this.productElement.querySelector('.explanation-dialog-btn');
        const inputRadioMostPrequentylyChosen = this.productElement.querySelector('input[most-frequently-chosen="true"]');
        const pdpKlaviyoBtn = this.productElement.querySelector('.klaviyo-bis-trigger');
      
        // App blocks
        const trustPilotWidget = this.productElement.querySelector('.trustpilot-widget');
        const estimatedShippingWidget = this.productElement.querySelector('.ot-estimated-shipping');
        const judgemePreviewBadge = this.productElement.querySelector('.jdgm-preview-badge');
      
        // Safe operations for elements that might not exist
        if (productPrice) {
          productPrice.parentNode.classList.add('quick-add-price-element');
        }
        
        const quickAddPriceElement = this.productElement.querySelector('.quick-add-price-element');
        
        if (judgemePreviewBadge && judgemePreviewBadge.parentNode) {
          judgemePreviewBadge.parentNode.classList.add('jdgm-preview-badge-container');
        }
        
        const judgemePreviewBadgeContainer = this.productElement.querySelector('.jdgm-preview-badge-container');
      
        // Handle most frequently chosen variant
        if (inputRadioMostPrequentylyChosen) {
          const inputRadioMostPrequentylyChosenVariantId = inputRadioMostPrequentylyChosen.getAttribute('most-frequently-chosen-variant-id');
          const variantIdElement = this.productElement.querySelector('.product-variant-id');
          if (variantIdElement) {
            variantIdElement.setAttribute('value', inputRadioMostPrequentylyChosenVariantId);
          }
        }
      
        // Remove elements safely
        safeOperation(breadcrumbs, el => el.remove());
        safeOperation(nfBadge, el => el.remove());
        safeOperation(productButtonMobile, el => el.remove());
        safeOperation(productTitle, el => el.remove());
        safeOperation(quickAddPriceElement, el => el.remove());
        safeOperation(productText, el => el.remove());
        safeOperation(productShorDescription, el => el.remove());
        safeOperation(uspProductCard, el => el.remove());
        safeOperation(mediaWrapper, el => el.remove());
        safeOperation(mediaGallery, el => el.remove());
        safeOperation(viewFullDetail, el => el.remove());
        safeOperation(stockWrapper, el => el.remove());
        safeOperation(productPayment, el => el.remove());
        safeOperation(trustPilotWidget, el => el.remove());
        safeOperation(estimatedShippingWidget, el => el.remove());
        safeOperation(judgemePreviewBadgeContainer, el => el.remove());
        safeOperation(pdpKlaviyoBtn, el => el.remove());
      
        // Remove each USP wrap element
        if (uspWrap && uspWrap.length > 0) {
          uspWrap.forEach(usp => {
            if (usp) usp.remove();
          });
        }
      
        // Create new elements structure safely
        if (productInfoContainer) {
          const producttitleAndImage = document.createElement('div');
          producttitleAndImage.classList.add('main-product-drawer-image');
          
          const productTitleAndPrice = document.createElement('div');
          productTitleAndPrice.classList.add('main-product-drawer-title-price');
      
          // Append children only if they exist
          safeOperation(productTitle, el => productTitleAndPrice.appendChild(el));
          safeOperation(productText, el => productTitleAndPrice.appendChild(el));
          safeOperation(quickAddPriceElement, el => productTitleAndPrice.appendChild(el));
          safeOperation(viewFullDetail, el => productTitleAndPrice.appendChild(el));
      
          safeOperation(mediaGallery, el => producttitleAndImage.appendChild(el));
          producttitleAndImage.appendChild(productTitleAndPrice);
          
          productInfoContainer.prepend(producttitleAndImage);
        }
      }

    }
  );
}
